import { render, staticRenderFns } from "./ShowMoreButtonFacultative.vue?vue&type=template&id=c90a2158&scoped=true&"
import script from "./ShowMoreButtonFacultative.vue?vue&type=script&lang=js&"
export * from "./ShowMoreButtonFacultative.vue?vue&type=script&lang=js&"
import style0 from "./ShowMoreButtonFacultative.vue?vue&type=style&index=0&id=c90a2158&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90a2158",
  null
  
)

export default component.exports